import { useState } from "react";
import Editor from "../../../components/RichTextEditor/Editor"

export const EMPTY_SEO = {
    meta_title: "",
    meta_description: "",
    meta_keywords: "",
    canonical_url: "",
    og_title: "",
    og_description: "",
    twitter_title: "",
    twitter_description: "",
    robots_index: true,

    seo_content: "",
};

export const EMPTY_SCHEMA = {
    enable_webpage: true,
    custom_json: "",
    additional_schema_type: "",
    additional_schema_data: {},
};

// export const mergeSeo = (s) => ({ ...EMPTY_SEO, ...(s && typeof s === "object" ? s : {}) });
// export const mergeSchema = (s) => ({
//   ...EMPTY_SCHEMA,
//   ...(s && typeof s === "object" ? s : {}),
//   additional_schema_data:
//     s?.additional_schema_data && typeof s.additional_schema_data === "object" ? s.additional_schema_data : {},
// });


const toObj = (v) => {
    if (typeof v === "string") {
        try { v = JSON.parse(v); } catch { return {}; }
    }
    return v && typeof v === "object" && !Array.isArray(v) ? v : {};
};

export const mergeSeo = (s) =>resolveSeo ({ ...EMPTY_SEO, ...toObj(s) });
export const mergeSchema = (s) => {
    const o = toObj(s);
    return { ...EMPTY_SCHEMA, ...o, additional_schema_data: toObj(o.additional_schema_data) };
};

const ADDITIONAL_SCHEMA_FIELDS = {
    Organization: [
        ["name", "Organization name"],
        ["url", "Organization URL"],
        ["description", "Organization description", true],
        ["logo", "Logo URL"],
    ],
    Service: [
        ["name", "Service name"],
        ["description", "Service description", true],
        ["url", "Service URL"],
        ["provider_name", "Provider name"],
    ],
    SoftwareApplication: [
        ["name", "Application name"],
        ["description", "Application description", true],
        ["url", "Application URL"],
        ["application_category", "Application category"],
        ["operating_system", "Operating system"],
    ],
};

const buildAdditionalSchema = (type, values = {}) => {
    const v = (k, fb = "") => values[k]?.trim() || fb;
    switch (type) {
        case "Organization":
            return { "@context": "https://schema.org", "@type": "Organization", name: v("name"), url: v("url"), description: v("description"), logo: v("logo") };
        case "Service":
            return { "@context": "https://schema.org", "@type": "Service", name: v("name"), description: v("description"), url: v("url"), provider: { "@type": "Organization", name: v("provider_name", "Procman") } };
        case "SoftwareApplication":
            return { "@context": "https://schema.org", "@type": "SoftwareApplication", name: v("name"), description: v("description"), url: v("url"), applicationCategory: v("application_category", "BusinessApplication"), operatingSystem: v("operating_system", "Web") };
        default:
            return null;
    }
};

// const cls = "w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500";
const cls = "w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 placeholder:text-gray-600 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500";
// const cls = "w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 placeholder:!text-gray-300 placeholder:italic placeholder:!opacity-100 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500";

function Row({ label, value, onChange, textarea, error, placeholder }) {
    const Tag = textarea ? "textarea" : "input";
    return (
        <label className="block">
            <span className="mb-1 block text-sm font-medium text-gray-700">{label}</span>
            <Tag
                {...(textarea ? { rows: 3 } : { type: "text" })}
                autoComplete="off"
                name={`blog_${label.toLowerCase().replace(/\s+/g, "_")}`}
                className={`${cls} ${error ? "!border-red-400" : ""}`}
                value={value || ""}
                placeholder={placeholder}
                onChange={(e) => onChange(e.target.value)}
            />
            {error && <span className="mt-1 block text-xs font-medium text-red-600">{error}</span>}
        </label>
    );
}

const Block = ({ title, description, children }) => (
    <div className="space-y-4 rounded-lg border border-gray-200 bg-gray-50/50 p-4">
        <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-700">{title}</h3>
            {description && <p className="mt-1 text-xs text-gray-500">{description}</p>}
        </div>
        {children}
    </div>
);

export const BLOG_BASE_URL = "https://procman.ai/blog/";
export const canonicalFor = (slug) => (slug ? `${BLOG_BASE_URL}${slug}` : "");

export const checkSocialImage = (file) =>
    new Promise((resolve) => {
        if (!["image/jpeg", "image/png", "image/webp"].includes(file.type))
            return resolve("Only JPG, PNG and WEBP images are allowed.");
        if (file.size > 2 * 1024 * 1024) return resolve("Image size must not exceed 2 MB.");
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
            URL.revokeObjectURL(url);
            resolve(img.width < 600 || img.height < 315 ? "Minimum image size is 600 × 315 px." : null);
        };
        img.onerror = () => { URL.revokeObjectURL(url); resolve("Invalid image file."); };
        img.src = url;
    });

export const resolveSeo = (seo = {}) => {
    const og_title = seo.og_title?.trim() || seo.meta_title || "";
    const og_description = seo.og_description?.trim() || seo.meta_description || "";
    return {
        ...seo,
        og_title,
        og_description,
        twitter_title: seo.twitter_title?.trim() || og_title,
        twitter_description: seo.twitter_description?.trim() || og_description,
    };
};


// meta -> og -> twitter: target tab tak source ko follow kare jab tak empty ho ya old source ke barabar ho
// export const syncSeo = (seo, key, value) => {
//     const next = { ...seo, [key]: value };
//     const follow = (target, source) => {
//         if (!seo[target] || seo[target] === seo[source]) next[target] = next[source];
//     };
//     if (key === "meta_title") { follow("og_title", "meta_title"); follow("twitter_title", "og_title"); }
//     if (key === "meta_description") { follow("og_description", "meta_description"); follow("twitter_description", "og_description"); }
//     if (key === "og_title") follow("twitter_title", "og_title");
//     if (key === "og_description") follow("twitter_description", "og_description");
//     return next;
// };

// Meta title/description change hone par OG + Twitter auto-sync (har baar overwrite)
export const syncSeo = (seo, key, value) => {
    const next = { ...seo, [key]: value };

    if (key === "meta_title") {
        next.og_title = value;
        next.twitter_title = value;
    }
    if (key === "meta_description") {
        next.og_description = value;
        next.twitter_description = value;
    }
    // OG edit karne par Twitter bhi follow kare (pehle jaisa behaviour)
    if (key === "og_title") next.twitter_title = value;
    if (key === "og_description") next.twitter_description = value;

    return next;
};

function ImageField({ label, preview, fallback, fallbackNote, error, onPick }) {
    const shown = preview || fallback;
    return (
        <div className="flex items-start gap-4">
            {shown ? (
                <img src={shown} alt={label} className="h-24 w-36 flex-none rounded-lg border border-gray-200 object-cover" />
            ) : (
                <div className="grid h-24 w-36 flex-none place-items-center rounded-lg border border-dashed border-gray-300 bg-gray-50 text-xs text-gray-400">
                    No image
                </div>
            )}
            <div>
                <span className="mb-1 block text-sm font-medium text-gray-700">{label}</span>
                <input
                    type="file"
                    accept="image/png,image/jpeg,image/webp"
                    onChange={(e) => {
                        const file = e.target.files?.[0];
                        e.target.value = "";
                        if (file) onPick(file);
                    }}
                    className="text-sm text-gray-600 file:mr-3 file:rounded-lg file:border-0 file:bg-gray-100 file:px-3 file:py-2 file:text-sm file:font-medium file:text-gray-700 hover:file:bg-gray-200"
                />
                {error ? (
                    <span className="mt-1 block text-xs font-medium text-red-600">{error}</span>
                ) : (
                    <span className="mt-1 block text-xs text-gray-500">
                        {!preview && fallback ? fallbackNote : "JPG, PNG, WEBP • Recommended 1200×630 px • Max 2 MB"}
                    </span>
                )}
            </div>
        </div>
    );
}


export default function BlogSeoSchema({ seo, schema, onSeoChange, onSchemaChange, errors = {}, ogPreview, twitterPreview, featuredPreview, onOgImage, onTwitterImage }) {
    const [preview, setPreview] = useState(null);
    const setSeo = (key) => (value) => onSeoChange(syncSeo(seo, key, value));
    // const fb = resolveSeo(seo);
    const type = schema?.additional_schema_type || "";
    const values = schema.additional_schema_data || {};
    const fields = ADDITIONAL_SCHEMA_FIELDS[type] || [];

    return (
        <div className="space-y-6 border-t border-gray-100 pt-6">
            <Block title="SEO">
                <Row label="Meta Title" value={seo.meta_title} onChange={setSeo("meta_title")} />
                <Row label="Meta Description" textarea value={seo.meta_description} onChange={setSeo("meta_description")} />
                <Row label="Meta Keywords" value={seo.meta_keywords} onChange={setSeo("meta_keywords")} />
                <Row label="Canonical URL" value={seo.canonical_url} onChange={setSeo("canonical_url")} />
                <div className="grid gap-4 sm:grid-cols-2">
                    <Row label="OG Title" value={seo.og_title} onChange={setSeo("og_title")} />
                    <Row label="Twitter Title" value={seo.twitter_title}  onChange={setSeo("twitter_title")} />
                    <Row label="OG Description" textarea value={seo.og_description} onChange={setSeo("og_description")} />
                    <Row label="Twitter Description" textarea value={seo.twitter_description}  onChange={setSeo("twitter_description")} />
                </div>
                <label className="block">
                    <span className="mb-1 block text-sm font-medium text-gray-700">Robots Index</span>
                    <select
                        className={cls}
                        value={seo.robots_index === false ? "noindex" : "index"}
                        onChange={(e) => setSeo("robots_index")(e.target.value === "index")}
                    >
                        <option value="index">index, follow</option>
                        <option value="noindex">noindex, nofollow</option>
                    </select>
                </label>
                <div>
                    <span className="mb-1 block text-sm font-medium text-gray-700">SEO Content</span>
                    {/* <RichTextEditor
                        value={seo.seo_content || ""}
                        onChange={(html) => setSeo("seo_content")(html)}
                        placeholder="Write SEO content..."
                        minHeight={300}
                    /> */}

                    <Editor
                     value={seo.seo_content || ""}
                        onChange={(html) => setSeo("seo_content")(html)}
                        placeholder="Write SEO content..."
                        minHeight={300}
                    />
                </div>
                <ImageField
                    label="OG Image"
                    preview={ogPreview}
                    fallback={featuredPreview}
                    fallbackNote="Using the featured image by default"
                    error={errors.og_image}
                    onPick={onOgImage}
                />
                <ImageField
                    label="Twitter Image"
                    preview={twitterPreview}
                    fallback={ogPreview || featuredPreview}
                    fallbackNote="Using the OG image by default"
                    error={errors.twitter_image}
                    onPick={onTwitterImage}
                />
            </Block>

            <Block title="Schema" description="Structured data (JSON-LD) stored with this blog.">
                <Row
                    label="Custom Schema JSON"
                    textarea
                    value={schema.custom_json}
                    error={errors.schema_custom_json}
                    onChange={(v) => onSchemaChange({ ...schema, custom_json: v })}
                />

                <label className="block">
                    <span className="mb-1 block text-sm font-medium text-gray-700">Additional schema type</span>
                    <select
                        className={cls}
                        value={type}
                        onChange={(e) => {
                            onSchemaChange({ ...schema, additional_schema_type: e.target.value, additional_schema_data: {} });
                            setPreview(null);
                        }}
                    >
                        <option value="">None</option>
                        <option value="Organization">Organization</option>
                        <option value="Service">Service</option>
                        <option value="SoftwareApplication">Software Application</option>
                    </select>
                </label>

                {fields.map(([key, label, textarea]) => (
                    <Row
                        key={key}
                        label={label}
                        textarea={textarea}
                        value={values[key]}
                        onChange={(v) => onSchemaChange({ ...schema, additional_schema_data: { ...values, [key]: v } })}
                    />
                ))}

                {type && (
                    <>
                        <button
                            type="button"
                            onClick={() => setPreview(buildAdditionalSchema(type, values))}
                            className="rounded-lg bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700"
                        >
                            Generate schema
                        </button>
                        {preview && (
                            <pre className="overflow-x-auto rounded-lg bg-slate-900 p-3 text-xs text-slate-200">
                                {JSON.stringify(preview, null, 2)}
                            </pre>
                        )}
                    </>
                )}
            </Block>
        </div>
    );
}